import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';
import { useAccount } from 'wagmi';

interface AdminRouteProps {
  children: ReactNode;
}

const AdminRoute = ({ children }: AdminRouteProps) => {
  const { isAuthenticated, isLoading, user } = useAuthStore();
  const { isConnected } = useAccount();
  const location = useLocation();

  // If authentication is still loading, show a loading indicator
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-dark-900">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary-500"></div>
      </div>
    );
  }

  // If user is not connected to a wallet, redirect to home with a message
  if (!isConnected) {
    return <Navigate to="/?message=Please connect your wallet" state={{ from: location }} replace />;
  }

  // If user is not authenticated, redirect to home
  if (!isAuthenticated) {
    return <Navigate to="/?message=Please sign in" state={{ from: location }} replace />;
  }

  // If user is not an admin, redirect to dashboard
  if (!user?.isAdmin) {
    return <Navigate to="/dashboard?message=Admin access required" state={{ from: location }} replace />;
  }

  // If authenticated and admin, render the protected content
  return <>{children}</>;
};

export default AdminRoute;